export default __webpack_public_path__ + "static/media/CERE_icon@2x.dd5bb3b7.png";